// Delay the submission of a form by waiting a bit, then reloading the page
// Assumes the form is a remote (ajax) form
//
// Ex:
// <form data-remote>
//
$(document).on('click', '[data-ajax-submit-delay] [type=submit]', function (e) {
  e.preventDefault();

  const $button = $(this);


  const $form = $button.parents('form');


  const disableText = $button.data('disable-with');

  if (disableText) {
    $button.text(disableText);
  }

  $form.trigger('reverb.storeCheckboxes');

  $.ajax({
    type: 'POST',
    url: $form.attr('action'),
    data: $form.serialize(),
  });

  setTimeout(() => { window.location.reload(); }, 2000);
});
